export function deleteCookie(name) {
  // Set the cookie with the same name and an expiration date in the past
  document.cookie = `${name}=; Max-Age=0; path=/`;
}
